module.exports = __webpack_public_path__ + "img/Ocean.13c2e64e.jpg";